import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/api';
import './trips.css';

const currency = (value) => `$${(Number(value) || 0).toFixed(2)}`;

const TripsPage = () => {
    const [trips, setTrips] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');
    const [cancellingReservationId, setCancellingReservationId] = useState(null);

    const loadTrips = async () => {
        setLoading(true);
        setMessage('');
        try {
            const response = await api.get('/direct-booking/guest/trips');
            setTrips(Array.isArray(response?.data) ? response.data : []);
        } catch (e) {
            setTrips([]);
            setMessage(e?.response?.data?.error || 'Unable to load upcoming trips.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadTrips();
    }, []);

    const cancelTrip = async (reservationId) => {
        setCancellingReservationId(reservationId);
        setMessage('');
        try {
            const response = await api.post(`/direct-booking/guest/trips/${reservationId}/cancel`, {});
            const refundedAmount = Number(response?.data?.refundedAmount) || 0;
            setMessage(refundedAmount > 0 ? `Trip cancelled. Refund initiated for ${currency(refundedAmount)}.` : 'Trip cancelled.');
            await loadTrips();
        } catch (e) {
            setMessage(e?.response?.data?.error || 'Unable to cancel this trip right now.');
        } finally {
            setCancellingReservationId(null);
        }
    };

    return (
        <div className="trips-page">
            <header className="trips-header">
                <h2>Upcoming Trips</h2>
                <p>See your upcoming reservations and jump into each booking chat.</p>
            </header>

            {message && <p className="trips-error">{message}</p>}
            {loading && <p>Loading upcoming trips...</p>}

            {!loading && trips.length === 0 && !message && (
                <div className="trips-empty-card">
                    <h3>No upcoming trips yet</h3>
                    <p>Once you book a stay, it will appear here.</p>
                    <Link className="btn-primary" to="/listings">Browse Listings</Link>
                </div>
            )}

            {!loading && trips.length > 0 && (
                <div className="trips-grid">
                    {trips.map((trip) => (
                        <article key={trip.reservationId} className="trips-card">
                            <div className="trips-card-media" style={{ backgroundImage: trip?.listing?.heroImageUrl ? `url(${trip.listing.heroImageUrl})` : 'none' }} />
                            <div className="trips-card-body">
                                <h3>{trip?.listing?.title || 'Upcoming stay'}</h3>
                                <p className="trips-location">{trip?.property?.city || ''}{trip?.property?.city && trip?.property?.state ? ', ' : ''}{trip?.property?.state || ''}</p>
                                <p><strong>Check-in:</strong> {trip.startDate}</p>
                                <p><strong>Check-out:</strong> {trip.endDate}</p>
                                <p><strong>Nights:</strong> {trip.nights}</p>
                                <p><strong>Total:</strong> {currency(trip.totalAmount)}</p>
                                {trip.refundedAmount > 0 && <p><strong>Refunded:</strong> {currency(trip.refundedAmount)}</p>}
                                <div className="trips-actions">
                                    {trip?.listing?.slug && <Link className="btn-secondary" to={`/book/${trip.listing.slug}`}>View Listing</Link>}
                                    <Link className="btn-primary" to="/Chat">Open Chat</Link>
                                    {trip.canCancel && (
                                        <button
                                            type="button"
                                            className="btn-danger"
                                            onClick={() => cancelTrip(trip.reservationId)}
                                            disabled={cancellingReservationId === trip.reservationId}
                                        >
                                            {cancellingReservationId === trip.reservationId ? 'Cancelling...' : 'Cancel Trip'}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TripsPage;
